export const INCREMENT_PAGE_COUNT_ACTION = 'INCREMENT_PAGE_COUNT';
